import { render, staticRenderFns } from "./xinaoZoneLayout.vue?vue&type=template&id=17f160ae&scoped=true"
import script from "./xinaoZoneLayout.vue?vue&type=script&lang=js"
export * from "./xinaoZoneLayout.vue?vue&type=script&lang=js"
import style0 from "./xinaoZoneLayout.vue?vue&type=style&index=0&id=17f160ae&prod&lang=sass"
import style1 from "./xinaoZoneLayout.vue?vue&type=style&index=1&id=17f160ae&prod&lang=css"
import style2 from "./xinaoZoneLayout.vue?vue&type=style&index=2&id=17f160ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f160ae",
  null
  
)

export default component.exports